import { IDeviceMobileItem } from '@/services/api/api.type';

import { formatDate } from 'utils';

type TFormatListParams = {
	total: number;
	page: number;
	pageSize: number;
};

export const formatDeviceMobileDetail = (
	input: IDeviceMobileItem,
	index: number,
	params: TFormatListParams
) => {
	return {
		...input,
		no: params.total - (params.page - 1) * params.pageSize - index,
		requestedAt: formatDate(input.requestedAt),
	};
};

export const formatDeviceMobileList = (
	input: IDeviceMobileItem[],
	params: TFormatListParams
) => {
	return input.map((item, index) =>
		formatDeviceMobileDetail(item, index, params)
	);
};
